import React from 'react';
import ConsentBanner from '../components/ConsentBanner';
import LandingFooter from '../components/landing/LandingFooter';

const LayoutSite = ({ children }) => (
  <React.Fragment>
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
    <div className="lp lp-site">
      <main className="site-content" id="main-content" role="main" tabIndex={-1}>
        {children}
      </main>
      <LandingFooter />
    </div>
    <ConsentBanner />
  </React.Fragment>
);

export default LayoutSite;
